module.exports = require("./sq-AL.js");